import { Directive, ElementRef, Renderer, Input } from "@angular/core";
export var FocusDirective = (function () {
    function FocusDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    FocusDirective.prototype.ngAfterViewInit = function () {
        if (this.value === "0") {
            return;
        }
        this.renderer.invokeElementMethod(this.el.nativeElement, "focus", []);
        if (this.value === "2") {
            var len = this.el.nativeElement.value.length;
            this.el.nativeElement.setSelectionRange(len, len);
        }
    };
    FocusDirective.decorators = [
        { type: Directive, args: [{
                    selector: "[ngxfocus]"
                },] },
    ];
    FocusDirective.ctorParameters = [
        { type: ElementRef, },
        { type: Renderer, },
    ];
    FocusDirective.propDecorators = {
        'value': [{ type: Input, args: ["ngxfocus",] },],
    };
    return FocusDirective;
}());
//# sourceMappingURL=ngx-my-date-picker.focus.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/directives/ngx-my-date-picker.focus.directive.js
// module id = 1333
// module chunks = 4